import makeHttpRequest from '../helpers/ajax';

const getOemAPIURL = () => {
    return WP_DEALERNETWORK_API_URL;
};

const requestData = (url, storageKey) => {
    const request = {
        url,
        expTime: 15 * 60 * 1000,
        storageKey,
        headers: {
            'x-requested-with': 'XMLHttpRequest',
        },
    };
    return request;
};

const getAutoRateOffers = (loanType, vehicleCondition = '', optionalParams = {}, callBackFunction = () => {}) => {
    try {
        const errorResponse = { success: false, errorMessage: `Unable to get Auto Rate Offers for this${loanType}` };
        let url = `${getOemAPIURL()}Offers/GetOffersAutoRateTable?loanType=${loanType}`;
        let storageKey = `AutoRateTableOffers_${loanType}`;
        if (vehicleCondition.trim().length > 0) {
            url = `${url}&vehicleCondition=${vehicleCondition}`;
            storageKey = `${storageKey}_${vehicleCondition}`;
        }

        if (Object.keys(optionalParams).length > 0) {
            Object.keys(optionalParams).forEach((key) => {
                if (optionalParams[key]) {
                    const value = optionalParams[key].toString().trim();
                    url = `${url}&${key}=${value}`;
                    storageKey = `${storageKey}_${value}`;
                }
            });
        }
        const request = requestData(url, storageKey);
        return makeHttpRequest(request).then((response) => {
            callBackFunction(JSON.parse(response));
        }, (error) => {
            console.warn(`There is some issue with network call for auto rate-table offers, please try again${JSON.stringify(error)}`);
            return errorResponse;
        });
    } catch (error) {
        if (WP_LT_ENV !== 'prod') {
            console.warn(`There is some issue with network call for Auto-Rate-Table-Service API, please try again${error}`);
        }
    }
    return false;
};

export default getAutoRateOffers;
